var _path, _path2, _rect, _path3, _path4, _circle, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 324,
    viewBox: "0 0 323 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.768 192.112C260.15 145.419 221.675 108.07 174.832 108.691C127.988 109.311 90.5159 147.666 91.1342 194.358",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.482 140.093C249.442 165.052 249.359 205.602 224.298 230.664L133.911 140.277C158.973 115.216 199.523 115.133 224.482 140.093Z",
    fill: "#FF304D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 135.019,
    y: 126.627,
    width: 146.087,
    height: 13.5652,
    transform: "rotate(45 135.019 126.627)",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.536 193.933L233.934 258.331C198.326 293.369 141.056 293.193 105.666 257.803C70.2754 222.412 70.0993 165.142 105.138 129.534L169.536 193.933Z",
    fill: "#E5E5E5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.146 79.7732L197.276 202.904",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 193.402,
    r: 30.2609,
    transform: "rotate(45 83 193.402)",
    fill: "#E5E5E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 193.402,
    r: 25.337,
    transform: "rotate(45 83 193.402)",
    fill: "#E5E5E5",
    stroke: "black",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.357,
    cy: 195.985,
    r: 20.8696,
    transform: "rotate(45 190.357 195.985)",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustration);
export default __webpack_public_path__ + "static/media/home_illustration.5f9683f8.svg";
export { ForwardRef as ReactComponent };